"use client";
import { useEffect } from "react";

type Props = { title: string };

export default function TitleUpdater({ title }: Props) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
